import { Constants } from "@eagerdog/constants";
import { IEventRegisterRow } from "../../../services/helper.service.js";
import { IShow } from "@eagerdog/interfaces";

export namespace AKCRallyObedience {
  export const getForm = (show?: IShow): IEventRegisterRow[] => {
    // Helper function to check if an element/level is available in the show
    const isElementAvailable = (elementOrLevel: string): boolean => {
      if (!show?.show_elements) return true; // If no show provided, show all options
      
      return show.show_elements.some(se => 
        se.show_element === elementOrLevel || se.level === elementOrLevel
      );
    };

    // Filter rally obedience options based on available show elements
    const rallyObedienceOptions = [
      {
        value: Constants.dog_class_element_level.novice_a,
        id: Constants.dog_class_element_level.novice_a,
      },
      {
        value: Constants.dog_class_element_level.novice_b,
        id: Constants.dog_class_element_level.novice_b,
      },
      {
        value: Constants.dog_class_element_level.intermediate,
        id: Constants.dog_class_element_level.intermediate,
      },
      {
        value: Constants.dog_class_element_level.advanced_a,
        id: Constants.dog_class_element_level.advanced_a,
      },
      {
        value: Constants.dog_class_element_level.advanced_b,
        id: Constants.dog_class_element_level.advanced_b,
      },
      {
        value: Constants.dog_class_element_level.excellent_a,
        id: Constants.dog_class_element_level.excellent_a,
      },
      {
        value: Constants.dog_class_element_level.excellent_b,
        id: Constants.dog_class_element_level.excellent_b,
      },
      {
        value: Constants.dog_class_element_level.master,
        id: Constants.dog_class_element_level.master,
      },
      {
        value: Constants.dog_class_element_level.choice,
        id: Constants.dog_class_element_level.choice,
      },
      {
        value: Constants.dog_class_element_level.pairs,
        id: Constants.dog_class_element_level.pairs,
      },
      {
        value: Constants.dog_class_element_level.novice_pairs,
        id: Constants.dog_class_element_level.novice_pairs,
      },
      {
        value: Constants.dog_class_element_level.advanced_pairs,
        id: Constants.dog_class_element_level.advanced_pairs,
      },
      {
        value: Constants.dog_class_element_level.excellent_pairs,
        id: Constants.dog_class_element_level.excellent_pairs,
      },
      {
        value: Constants.dog_class_element_level.team,
        id: Constants.dog_class_element_level.team,
      },
      {
        value: Constants.dog_class_element_level.novice_teams,
        id: Constants.dog_class_element_level.novice_teams,
      },
      {
        value: Constants.dog_class_element_level.advanced_teams,
        id: Constants.dog_class_element_level.advanced_teams,
      },
      {
        value: Constants.dog_class_element_level.rae,
        id: Constants.dog_class_element_level.rae,
      },
      {
        value: Constants.dog_class_element_level.rach,
        id: Constants.dog_class_element_level.rach,
      }
    ].filter(option => isElementAvailable(option.value));

    const formRows: IEventRegisterRow[] = [];

    // Only add rally obedience section if there are available options
    if (rallyObedienceOptions.length > 0) {
      formRows.push({
        allowDuplicates: false,
        inputs: [
          {
            type: "checkbox",
            label: Constants.dog_class_element.performance_rally_obedience,
            multiSelect: true,
            columnLayout: true,
            multiClassMessages: {
              [Constants.dog_class_element_level.rae]: "Advanced B, Excellent B",
              [Constants.dog_class_element_level.rach]: "Advanced B, Excellent B, Master"
            },
            options: rallyObedienceOptions
          },
        ],
      });
    }

    return formRows;
  };

  // Keep the original form for backward compatibility
  export const form: IEventRegisterRow[] = getForm();
}
